<div
  class="product-card product-card_size_{{ size }}"
  [class.product-card__status_new]="isNew"
  [class.product-card__status_archive]="isArchive"
  [class.product-card__status_review]="isReview"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_rounded]="loading"
  [routerLink]="['/loyalty', 'product', product?.id]"
  [queryParams]="{ unionId: externalUnionId, collectionId, ref }"
>
  <div class="product-card__image-block">
    <tui-badge
      *ngIf="!!statusText"
      class="status"
      [class.status_new]="isNew"
      [class.status_archive]="isArchive"
      [class.status_review]="isReview"
      [size]="isMobile ? 's' : 'm'"
    >
      {{ statusText }}
    </tui-badge>

    <img
      *ngIf="!!coverImgId"
      class="image"
      alt="Product cover"
      [class.image_opacity]="isArchive"
      [src]="coverImgId | getImageSrc: 'Product image' : 'thumbnail' : externalUnionId"
    />
  </div>

  <div class="product-card__text-block">
    <div *ngIf="(showDiscount && !!discountText) || showIsFavorite" class="row">
      <app-badge
        *ngIf="showDiscount && !!discountText"
        class="discount"
        [value]="discountText"
        [color]="'blue'"
        [size]="'l'"
      ></app-badge>

      <lp-favorite-button *ngIf="showIsFavorite" class="favorite" [product]="product" [size]="'m'"></lp-favorite-button>
    </div>

    <span class="text">{{ product?.name }}</span>
  </div>
</div>
